import React, { useEffect, useRef} from "react"
// import { compose } from "redux"
//import DataTable from 'components/DataTable'
import MetaTags from "react-meta-tags"
// import withQueryParams from "react-router-query-params"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input
  // CardTitle
} from "reactstrap"

//Import Styles
import "./styles.scss"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import SimpleReactValidator from "simple-react-validator"

function Records(props) {

  useEffect(() => {
    console.log(" props ", props)
    // console.log("props session", props.getLeadDetails())
  }, [])

  const title = "MANAGE LEAD"


   //Validator
   const simpleValidator = useRef(new SimpleReactValidator())

  const CardOject = [
    {backgroundColor:'#0D70E2', count:'0|0|0', title:'Lead - Todays | MTD | Overall', color:'#fff'},
    {backgroundColor:'#f1b54c', count:'0|0|0', title:'Unactioned - Todays | MTD | Overall', color:'#fff'},
    {backgroundColor:'#34c28f', count:'0|0|0', title:'Conversions - Todays | MTD | Overall', color:'#fff'},
    {backgroundColor:'#f46969', count:'0|0|0', title:'Rejected - Todays | MTD | Overall', color:'#fff'},
    {backgroundColor:'#50a5f0', count:'0|0|0', title:'Follow - Ups Pending - Todays | MTD | Overall', color:'#fff'},
    {backgroundColor:'#353a40', count:'0|0|0', title:'Run Rate - Current RR | Required RR', color:'#fff'}

  ]

  const handleChange = async (e, value) => {
    console.log(e)
    console.log(value)

  }

  return (
    <React.Fragment>
      <div className="page-layout">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={title} breadcrumbItem={title} />

          <Row>

            {/* Button Start */}
            <Row style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '12px' }}>
              <Col style={{ flex: '1 2', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    id="add-lead-btn"
                    color="primary">
                    {`Add New Lead`}
                  </Button>
              </Col>
            </Row>
            {/* Button End */}

            <Card>
              <CardBody>
                <Col md={12}>

                  {/* Counter Start */}
                  <Col xs={12}>
                        <Row style={{ alignItems: 'center' }}>

                        {CardOject.map((data,key) => (
                          <Col lg={2} key={key}>
                          <Card style={{backgroundColor:data.backgroundColor}} className="text-white-50 cardStyle" >
                              <CardBody>
                                  <h4 style={{color:data.color}}>{data.count}</h4>
                                  <h6 style={{color:data.color}}>{data.title}</h6>
                              </CardBody>
                          </Card>
                          </Col>
                        ))}
                          

                        </Row>
                  </Col>
                  {/* Counter End */}

                </Col>
              </CardBody>
            </Card>


            <Card>
              <CardBody>
                {/* Form Start */}

                <form>
                <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                  <div className="d-flex justify-content-between">
                    <Label className="event-label">
                      Follow-Up Date
                      <span className="event-required">*</span>
                    </Label>
                  </div>
                  <Input
                    type="date"
                    name="cFDate"
                    value={""}
                    onChange={(e) =>
                      handleChange(e, "")
                    }
                    placeholder="Select Date"
                  />
                  {simpleValidator.current.message(
                    "Follow-Up Date",
                    "",
                    "required"
                  )}
                </Col>

                </form>


                {/* Form End */}
              </CardBody>
            </Card>



          </Row>
          
        </Container>
      </div>

    </React.Fragment>
  )
}



export default Records

